/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PointPreviousFilledIcon = /*#__PURE__*/ createSvgIcon(
  'PointPreviousFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.82 7.48h8.65s-.55-2.23-.74-3.08C10 1 12.24 1 12.24 1l2.26 4.73c.75 1.7 1.5 2.55 3 2.55H19v8.1h-2.36C15.05 18 14.29 18 13.4 18h-4A2.3 2.3 0 017 16.38a18.942 18.942 0 01-.8-3.24c-.09-.85-.11-2.43 2.3-2.43H2.82a1.629 1.629 0 110-3.23z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default PointPreviousFilledIcon;
